import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch6_p11 } from "../../../layouts/ch6_p11/ch6_p11";

export class Chapter6Page11 extends AbstractStoryState implements ReturnType<typeof ch6_p11> {

    readonly bg = this.addChild(new SceneSprite());
    readonly horse = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());
    readonly tyler = this.addChild(new SceneSprite());
    readonly rain = [this.addChild(SceneSprite.withPrefix("ch6_p11/")), this.addChild(SceneSprite.withPrefix("ch6_p11/"))];

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch6_p11/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch6_p11/"));
    readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch6_p11/"));
    readonly linesRight = this.addChild(SceneSprite.withPrefix("ch6_p11/"));

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch6_p11.call(this);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        TweenLite.delayedCall(1.5, ()=>{
            this.gotoNextState({transition: "up"});
        });
    }

}